import React, { useState, useEffect } from 'react';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';

export const BookingsView = () => {
  const [bookings, setBookings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Service Bookings</h2>
          <p className="text-gray-600">View and manage service appointments</p>
        </div>
        <div className="flex items-center gap-2">
          <Calendar className="w-5 h-5 text-gray-600" />
          <span className="text-2xl font-bold text-gray-900">{bookings.length}</span>
        </div>
      </div>

      {isLoading ? (
        <p className="text-center text-gray-600 py-8">Loading bookings...</p>
      ) : bookings.length === 0 ? (
        <div className="text-center py-12">
          <Calendar className="w-12 h-12 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-600">No bookings yet</p>
        </div>
      ) : (
        <div className="space-y-4">
          {bookings.map((booking) => (
            <div
              key={booking.booking_number}
              className="border-2 border-gray-200 rounded-lg p-4"
            >
              {/* Booking details */}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};